var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-fast"}},[(_vm.value)?_c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:_vm.$style.buttons},[_vm._t("buttons")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }